import { render, staticRenderFns } from "./onboarding.vue?vue&type=template&id=e8eea29a&scoped=true&"
import script from "./onboarding.vue?vue&type=script&lang=js&"
export * from "./onboarding.vue?vue&type=script&lang=js&"
import style0 from "./onboarding.vue?vue&type=style&index=0&id=e8eea29a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8eea29a",
  null
  
)

export default component.exports